import { Box, Flex, Grid, GridItem, Image, Input, Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from "@chakra-ui/react";
import MyDiv from "./ThoughtOfTheDay.style";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { AlertCard, CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IThought } from "./model";
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
    { id: 1, head: "S. No" },
    { id: 4, head: "Thought" },
    { id: 6, head: "Status" },
    { id: 7, head: "Actions" },
];

const ThoughtOfTheDay = () => {
    const [thoughts, setThoughts] = useState<IThought[]>([]);
    const [AlertOpen, setAlertOpen] = useState(false);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentThought, setCurrentThought] = useState({ id: 0, thought: "", status: true, });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [statusChangeSource, setStatusChangeSource] = useState<"table" | "drawer" | null>(null);

    useEffect(() => {
        loadThoughts();
    }, []);

    const loadThoughts = async () => {
        const response = await fetchApi<IThought[] | IThought>("Thought", "GET");

        if (response) {
            if (Array.isArray(response)) {
                setThoughts(response);
            } else {
                setThoughts([response]); // wrap single object in array
            }
        }
    };


    const handleStatusChange = (id: number, newStatus: boolean) => {
        setSelectedId(id);
        setPendingStatus(newStatus);
        setStatusChangeSource("table");
        setAlertOpen(true);
    };

    const handleDrawerStatusChange = (newStatus: boolean) => {
        setPendingStatus(newStatus);
        setStatusChangeSource("drawer");
        setAlertOpen(true);
    };

    const handleConfirmStatusChange = async () => {
        if (selectedId !== null && pendingStatus !== null) {
            const thoughtId = statusChangeSource === "table" ? selectedId : currentThought.id;

            const response = await fetchApi(`Thought/changestatus/${thoughtId}`, "PUT", { Id: thoughtId, Status: pendingStatus });
            if (response) {
                if (statusChangeSource === "table") {
                    setThoughts((prev) => prev.map((thought) => thought.id === selectedId ? { ...thought, status: pendingStatus } : thought));
                } else {
                    setCurrentThought((prev) => ({ ...prev, status: pendingStatus }));
                }
            }
        }
        setAlertOpen(false);
    };

    const handleAddNewScore = () => {
        setIsEditMode(false);
        setCurrentThought({ id: 0, thought: "", status: true });
        setDrawerOpen(true);
    };

    const handleEditScore = (thought: IThought) => {
        setIsEditMode(true);
        setSelectedId(thought.id);
        setCurrentThought(thought);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setCurrentThought((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (isEditMode) {
            const response = await fetchApi(`Thought/${currentThought.id}`, "PUT", { id: currentThought.id, thought: currentThought.thought, status: currentThought.status, }, null, "Thought updated successfully");

            if (response){ setThoughts((prev) => prev.map((thought) => (thought.id === selectedId ? currentThought : thought))); loadThoughts() };
        } else {
            const response = await fetchApi<IThought>("Thought", "POST", { thought: currentThought.thought, status: currentThought.status, }, null, "Thought added successfully");
            if (response) { setThoughts((prev) => [...prev, response]); loadThoughts() };
        }
        setDrawerOpen(false);
    };

    const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>) : (
                    <>
                        <Flex className="page_heading flex_header">
                            <Text className="font-poppins text_semibold text_3xl">Thoughts</Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New Thoughts" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewScore} />
                            </Flex>
                        </Flex>
                        <Grid className="grid_container">
                            <GridItem colSpan={12}>
                                <CustomTable value={thoughts} >
                                  <Column header="S. No" body={(_, index) => index + 1} />
                                  <Column header="Thought" field="thought" />
                                  <Column
                                    header="Status"
                                    body={(row: any) => (
                                      <Select
                                        value={row.status ? "true" : "false"}
                                        onChange={(e) => handleStatusChange(row.id, e.target.value === "true")}
                                        width="120px"
                                        height="32px"
                                        icon={<ChevronDownIcon />}
                                        borderRadius="4px"
                                        color={getStatusColor(row.status)}
                                        className="font-poppins text_medium text_xsm"
                                      >
                                        <option value="true" style={{ color: "#38A169" }}>Active</option>
                                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                                      </Select>
                                    )}
                                  />
                                     <Column
                                       header="Actions"
                                       body={(row: any) => <ActionEditIcon onClick={() => handleEditScore(row)} />}
                                     />
                                   </CustomTable>

                            </GridItem>
                        </Grid>

                        <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />

                        <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit Thought" : "Add New Thought"}</DrawerHeader>
                                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between">
                                    <Box py={4}>
                                        <FormControl mb={4}>
                                            <FormLabel>Thought</FormLabel>
                                            <Input name="thought" value={currentThought.thought} onChange={handleInputChange} placeholder="Enter Thought of the day" />
                                        </FormControl>
                                        <FormControl mb={4}>
                                            <FormLabel>Status</FormLabel>
                                            <Select w="120px" value={currentThought.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentThought.status)}>
                                                <option value="true" style={{ color: "#38A169" }}> Active</option>
                                                <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Flex justify="flex-end" mt={4} gap={2}>
                                        <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}>Cancel</Button>
                                        <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }} isLoading={loading} >{isEditMode ? "Update Thought" : "Add Thought"}</Button>
                                    </Flex>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>
                    </>)}
            </Box>
        </MyDiv>
    );
};
export default ThoughtOfTheDay;
